import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  is_corporate: true,
  client_application_id: null,
  company_id: null,
  client_applicant_id: null,
  applicant_type: null,
  is_kyc: false,
  nafath_code: null,
  is_ksa_corporate: false,
  client_id: null,
  rejection_msg: null,
};

const constantSlice = createSlice({
  name: 'constant',
  initialState,
  reducers: {
    setIsCorporate: (state, action) => {
      state.is_corporate = action.payload;
    },
    setClientApplicationId: (state, action) => {
      state.client_application_id = action.payload;
    },
    setCompanyId: (state, action) => {
      state.company_id = action.payload;
    },
    setClientApplicantId: (state, action) => {
      state.client_applicant_id = action.payload;
    },
    setApplicantType: (state, action) => {
      state.applicant_type = action.payload;
    },
    setIsKyc: (state, action) => {
      state.is_kyc = action.payload;
    },
    setNafathCode: (state, action) => {
      state.nafath_code = action.payload;
    },
    setKsaCorporate: (state, action) => {
      state.is_ksa_corporate = action.payload;
    },
    setClientId: (state, action) => {
      state.client_id = action.payload;
    },
    setRejectionMsg: (state, action) => {
      state.rejection_msg = action.payload;
    },
  },
});

export const {
  setIsCorporate,
  setClientApplicationId,
  setCompanyId,
  setClientApplicantId,
  setApplicantType,
  setIsKyc,
  setNafathCode,
  setKsaCorporate,
  setClientId,
  setRejectionMsg,
} = constantSlice.actions;
export default constantSlice.reducer;
